<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="用户ID" prop="type">
            <el-input
              v-model.number="queryParams.uid"
              placeholder="请输入用户ID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>用户消耗列表</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
          :header-cell-class-name="handleHeaderClass"
          @header-click="handleHeaderCLick"
          @sort-change="handleTableSort"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            align="center"
          />
          <el-table-column
            prop="level_id"
            label="用户等级"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="obtain_spin"
            label="获得体力"
            align="center"
            sortable="custom"
          />

          <el-table-column
            prop="cost_spin"
            label="消耗体力"
            align="center"
            sortable="custom"
          />

          <el-table-column
            prop="obtain_coin"
            label="获得金币"
            align="center"
            sortable="custom"
          />

          <el-table-column
            prop="cost_coin"
            label="消耗金币"
            align="center"
            sortable="custom"
          />

          <el-table-column
            prop="obtain_card"
            label="获取卡片数量"
            align="center"
            sortable="custom"
          />

          <el-table-column
            prop="cost_card"
            label="消耗卡片数量"
            align="center"
            sortable="custom"
          />

          <el-table-column
            prop="spin_times"
            label="转动次数"
            align="center"
            sortable="custom"
          />

          <el-table-column
            prop="stock_coin"
            label="金币存量"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="stock_spin"
            label="体力存量"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="obtain_diamond"
            label="获得钻石"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="cost_diamond"
            label="消耗钻石"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="stock_diamond"
            label="钻石存量"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="stock_beast_coin"
            label="野兽币存量"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="obtain_beast_coin"
            label="获得野兽币"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="cost_beast_coin"
            label="消耗野兽币"
            align="center"
            sortable="custom"
          />
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables()"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { exportUserStatList, getUserStat } from '@/api/user/user_info'
export default {
  name: 'UserStat',
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        uid: '',
        order: '',
        startDate: '',
        endDate: ''
      },
      ordersList: [],
      tableData: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    actUid(uid) {
      this.$router.push({ name: 'User', query: { uid: uid }})
    },
    handleQuery() {
      const uid = this.queryParams.uid
      if (isNaN(uid)) {
        this.msgError('用户UID有误！')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      getUserStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list.data
          this.total = res.data.count
          this.queryParams.startDate = res.data.list.req.StartDate
          this.queryParams.endDate = res.data.list.req.EndDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      exportUserStatList(this.queryParams).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleHeaderClass({ column }) {
      column.order = column.multiOrder
    },
    handleHeaderCLick(column) {
      if (column.sortable !== 'custom') {
        return
      }
      if (!column.multiOrder) {
        column.multiOrder = 'descending'
      } else if (column.multiOrder === 'descending') {
        column.multiOrder = 'ascending'
      } else {
        column.multiOrder = ''
      }
      this.handleOrderChange(column.property, column.multiOrder)
    },
    handleOrderChange(orderColumn, orderState) {
      const result = this.ordersList.find(e => e.orderColumn === orderColumn)
      if (result) {
        result.orderState = orderState
      } else {
        this.ordersList.push({
          orderColumn: orderColumn,
          orderState: orderState
        })
      }
      // this.getDataList()
      if (this.ordersList.length > 0) {
        this.queryParams.order = JSON.stringify(this.ordersList)
        this.handleQuery()
      }
    },
    handleTableSort({ column, prop, order }) {
      // 有些列不需要排序，提前返回
      if (column.sortable !== 'custom') {
        return
      }
      console.log('column', column.multiOrder)
      if (!column.multiOrder) {
        column.multiOrder = 'descending'
      } else if (column.multiOrder === 'descending') {
        column.multiOrder = 'ascending'
      } else {
        column.multiOrder = ''
      }

      this.handleOrderChange(column.property, column.multiOrder)
    }
  }
}
</script>

<style scoped>
</style>
